import { render, staticRenderFns } from "./ModalAddTab.vue?vue&type=template&id=15feba52"
import script from "./ModalAddTab.vue?vue&type=script&lang=js"
export * from "./ModalAddTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15feba52')) {
      api.createRecord('15feba52', component.options)
    } else {
      api.reload('15feba52', component.options)
    }
    module.hot.accept("./ModalAddTab.vue?vue&type=template&id=15feba52", function () {
      api.rerender('15feba52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/ModalAddTab.vue"
export default component.exports